module.exports = __webpack_public_path__ + "static/media/nicole_english_aus.a4855576.mp3";